<template>
    <v-text-field
        :label="$t('instance.data_model.form_editor.fields_types.number_field.default_field')"
        type="number"
        v-model="valueCopy"
        :rules="rules"
        :disabled="readOnly"
        @change="emitValue"
    ></v-text-field>
</template>

<script>

import FieldMixin from './field-mixin.vue';
export default {
    mixins: [FieldMixin],
    components: {

    },

    props: {

    },

    data (){
        return {

        };
    },

    computed: {
        rulesList (){
            return {
                int: this.formActive ?[v => Number.isInteger(parseFloat(v)) || this.$t('instance.data_model.form_editor.fields_types.number_field.rules.int')]: [],
                bigint: this.formActive ?[v => Number.isInteger(parseFloat(v)) || this.$t('instance.data_model.form_editor.fields_types.number_field.rules.bigint')]: [],
                float: this.formActive ?[v => /^[+-]?\d+(\.\d+)?$/.test(v) || this.$t('instance.data_model.form_editor.fields_types.number_field.rules.float')]: [],
                decimal: this.formActive ?[v => /^[+-]?\d+(\.\d+)?$/.test(v) || this.$t('instance.data_model.form_editor.fields_types.number_field.rules.decimal')]: [],
            };
        },
    },

    mounted (){

    },

    methods: {
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/FieldsTypes/number-field.vue